var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

import React from 'react';
import { FormattedNumber } from 'react-intl';
import PropTypes from 'prop-types';

/**
 * For crypto we want more decimals.
 */
var fractionDigits = {
  BTC: { min: 5, max: 5 },
  LTC: { min: 5, max: 5 },
  XBC: { min: 5, max: 5 },
  ETH: { min: 5, max: 5 },
  BCH: { min: 5, max: 5 },
  XRP: { min: 3, max: 3 }
};

/**
 * FormattedNumber component to display currency
 */
var Money = function Money(props) {
  return React.createElement(FormattedNumber, _extends({
    minimumFractionDigits: props.decimals ? fractionDigits[props.currency] && fractionDigits[props.currency].min || 2 : 0,
    maximumFractionDigits: props.decimals ? fractionDigits[props.currency] && fractionDigits[props.currency].max || 2 : 0
  }, props, {
    style: 'currency'
  }));
};

Money.propTypes = {
  /**
   * The amount of desired currency to display
   */
  value: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),

  /**
   * The type of currency
   */
  currency: PropTypes.string
};

Money.defaultProps = {
  value: 0,
  currency: 'EUR',
  decimals: true
};

export var format = function format(currency) {
  var locale = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'en-US';
  return new Intl.NumberFormat(locale, {
    style: 'currency',
    currency: currency,
    minimumFractionDigits: fractionDigits[currency] ? fractionDigits[currency].min : null,
    maximumFractionDigits: fractionDigits[currency] ? fractionDigits[currency].max : null
  });
};

export default Money;